// Interface for the lookup request
export interface PaginatedLookupRequest {
  term: string;
  advancedFilter: AdvancedFilter[];
  includeDeleted: boolean;
  pageNumber: number;
  pageSize: number;
  orderBy: string[];
  // lookupType: string;
  category: string;
  branchId?: number;
}

export interface AdvancedFilter {
  logic: string;
  field: string;
  operator: string;
  value: string;
}

// Interface for the lookup response
export interface PaginationResponse<T> {
  data: T[];
  succeeded: boolean;
  errors: string[];
  message: string;
  statusCode: string;
  errorCode: string;
  referenceNumber: string;
  correlationId: string;
  elapsedTime: number;
  totalCount: number;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  meta: string;
}

// Interface for the simple lookup DTO
export interface SimpleLookupDto {
  id: number;
  nameEn: string;
  nameAr: string;
}

// Enum for lookup types
export enum LookupType {
  Countries = 'Countries',
  Currencies = 'Currencies',
  Customers = 'Customers',
  Vendors = 'Vendors',
  Contacts = 'Contacts',
  Accounts = 'Accounts',
  Products = 'Products',
  ProductCategories = 'ProductCategories',
  ProductGroups = 'ProductGroups',
  TaxCategories = 'TaxCategories',
  TaxExceptions = 'TaxExceptions',
  PriceLevels = 'PriceLevels',
  Units = 'Units',
  Roles = 'Roles',
  JournalTypes = 'JournalTypes',
  AccountType = 'AccountType',
  AccountCategories = 'AccountCategories',
  Branches = 'Branches',
  Stores = 'Stores',
  Companies = 'Companies',
  Employees = 'Employees',
  Users = 'Users',
  DocumentTypes = 'DocumentTypes',
  FinancialStatementItem = 'FinancialStatementItems',
  AccountCategory = 'AccountCategory',
  DocumentSubType = 'DocumentSubType',
  FinancialYear = 'FinancialYears',
  TemplateEvents = 'TemplateEvents',
  Shifts = 'Shifts',
  ShiftCategories = 'ShiftCategories',
  Pages = 'Pages',
  Modules = 'Modules',
  PageTypes = 'PageTypes',
  Tenants = 'Tenants',
  SubscriptionPackages = 'SubscriptionPackages',
  ZatcaStates = 'ZatcaStates',
  ShiftStatuses = 'ShiftStatuses',
  ProductsWithUnits = 'ProductsWithUnits',
  GlAccountWithCategories = 'GlAccountWithCategories',
  PurchaseRequest = 'PurchaseRequest',
  PurchaseOrder = 'PurchaseOrder',
  OfferPrices = 'offerPrices',
  PurchaseInvoices = "PurchaseInvoices",
  Documents = 'Documents',
  SalesOrders = 'SalesOrders',
  PaymentMethodLookup = 'PaymentMethodLookup',
}
